import { Component, Vue, Prop } from 'vue-property-decorator';
import { IMatchup, IFeatureValueSet, IFeatureValue } from '@/store/modules/game/interfaces';
import StatsService from '@/services/StatsService'

@Component
export default class MatchupStats extends Vue {
  @Prop() private matchup: IMatchup;

  private render(h: any): any {

    const stats = StatsService.generateStatsForMatchup(this.matchup.pickA, this.matchup.pickB, false)
    
    let statList;
    
    if (stats) {
      statList = stats.a.map((stat: IFeatureValue, idx: number) => { return (
        <tr class='avatar-stats-row'>
            <td class='avatar-data-cell avatar-data-left'>{StatsService.getRenderStat(stat)}</td>
            <td class='avatar-data-cell avatar-data-stat'><span>{stat.name}</span></td>
            <td class='avatar-data-cell avatar-data-right'>{StatsService.getRenderStat(stats.b[idx])}</td>
          </tr>
      )});
    }

    const emptyList = <tr>
      <td colspan='3'>We don't have stats available for this matchup yet!</td>
    </tr>

    return (
      <div class='pick-stats-content-inline'>
        <table>
          {statList || emptyList}
        </table>
      </div>
    );
  }
}
